import { trackEvent } from '../jentis/events';
import { TRACKING_ACTION, TRACKING_CATEGORY } from './constants';

export const trackOrderStatusEvent = (label: string) => trackEvent(TRACKING_CATEGORY, TRACKING_ACTION, label);
